export const TRAIL_FILTER_ALL = 'All';
export const TRAIL_FILTER_BLUEBLACK = 'blueBlack';
export const TRAIL_FILTER_GREENBLUE = 'greenBlue';
export const TRAIL_FILTER_BLUE = 'blue';
export const TRAIL_FILTER_BLACK = 'black';
export const TRAIL_FILTER_DBLACK = 'dblack';
export const TRAIL_FILER_GREEN = 'green';

export const SET_TRAIL_FILTER = 'SET_TRAIL_FILTER';
